import { createContext } from 'react';
import noop from 'lodash/noop';

type FocusRestorationContextType = {
	shouldRestoreFocusRef: { current: boolean };
	clearRestoreFocus?: () => void;
};

export const FocusRestorationContext = createContext<FocusRestorationContextType>({
	shouldRestoreFocusRef: { current: false },
	clearRestoreFocus: noop,
});
